import { render, staticRenderFns } from "./LegislationsSection.vue?vue&type=template&id=47b46b1c&scoped=true&"
import script from "./LegislationsSection.vue?vue&type=script&lang=js&"
export * from "./LegislationsSection.vue?vue&type=script&lang=js&"
import style0 from "./LegislationsSection.vue?vue&type=style&index=0&id=47b46b1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b46b1c",
  null
  
)

export default component.exports